import React from "react";
import LoadingLoginScreen from "../../../components/LoadingLoginScreen";
import { Alert, Button, Dropdown, Form } from "react-bootstrap";
import { addLeadAsAdminClient } from "../../../services/AdminService";
import { dealstages, dealstagesarr } from "../../../components/CONSTANTS";


export const AddLead = () => {

    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [errorText, setErrorText] = React.useState("");

    const companyRef = React.useRef("");
    const approvedRef = React.useRef(false);
    const [dealstageRef, setDealstageRef] = React.useState("");
    const emailRef = React.useRef("");
    const firstNameRef = React.useRef("")
    const lastNameRef = React.useRef("");
    const customerTypeRef = React.useRef("");
    const leadgeneratorRef = React.useRef();


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!companyRef.current.value) {
            setError(true);
            setErrorText("Ange företag");
            return;
        } else if (!approvedRef.current.value) {
            setError(true);
            setErrorText("Ange status");
            return;
        } else if (dealstageRef === "" || undefined) {
            setError(true);
            setErrorText("Ange dealstage");
            return;
        } else {


            try {
                await addLeadAsAdminClient(
                    companyRef.current.value,
                    approvedRef.current.value,
                    dealstageRef.current.value,
                    emailRef.current.value,
                    firstNameRef.current.value,
                    lastNameRef.current.value,
                    leadgeneratorRef.current.value
                )
            } catch (e) {
            }
        }
        setLoading(false);

    }


    return (
        <>
            {loading ? <LoadingLoginScreen />
                :
                <Form
                    onSubmit={handleSubmit}
                    style={{ padding: "10px", margin: "10px" }}
                >
                    {error ? <Alert variant='success'>
                        {errorText}
                    </Alert> : null}
                    <Form.Group className="mb-3">
                        <Form.Label>Företagsnamn</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Leadtub AB"
                            ref={companyRef}
                        />
                    </Form.Group>
                    {/*

                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                            Välj Företag
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {companies.map((company) =>
                                <Dropdown.Item
                                    key={company.id}
                                    eventKey={company.id}
                                    onSelect={function (evt) {
                                        setCompanyReference(evt)
                                    }}
                                >{company.companyName}</Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>

                    <Form.Group className="mb-3">
                        <Form.Label>Status</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Leadtub AB"
                            ref={approvedRef}
                        />
                    </Form.Group>


                <Form.Group className="mb-3">
                    <Form.Label>Dealstage</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Vilket dealstage?"
                        ref={dealstageRef}
                    />
                </Form.Group>
*/}
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                            Välj dealstage
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {dealstagesarr.map((deal) =>
                                <Dropdown.Item
                                    key={deal.id}
                                    eventKey={deal.id}
                                    onSelect={function (evt) {
                                        setDealstageRef(evt)
                                    }}
                                >{deal}</Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>

                    <Form.Group className="mb-3">
                        <Form.Label>Kundens email </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Dennis@leadtub.se"
                            ref={emailRef}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Typ av kund? </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Privat Person"
                            ref={customerTypeRef}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Förnamn på kunden</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Karl"
                            ref={firstNameRef}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Efternamn på kunden</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Karlsson"
                            ref={lastNameRef}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Vem har generetat leaden?</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Vem har generetat leaden?"
                            ref={leadgeneratorRef}
                        />
                    </Form.Group>


                    <Button variant="primary" type="submit">
                        Skapa Lead
                    </Button>

                </Form>
            }
        </>
    )
}
